/* Generated by scripts/sync-ai-lab-theme.mjs. Source: ai-lab-shopify/js/app.js */
(function () {
  'use strict';

  if (window.AILabTheme) {
    window.AILabTheme.mountWithin(document);
    return;
  }

  function readConfig(root) {
    var node = root.querySelector('[data-ai-lab-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function mountAiLab(root, config) {
  if (!root || root.__aiLabInstance) return root && root.__aiLabInstance;
    var chatConfig = config.h5 || {};
    var tracker = window.AILabTrackingFactory
      ? window.AILabTrackingFactory.create(config.tracking || {})
      : null;
    var track = tracker ? tracker.track : function () {};
    var getPageStartTime = tracker ? tracker.getPageStartTime : function () { return Date.now(); };
    var trackingSessionId = tracker ? tracker.getSessionId() : '';
    var abortController = new AbortController();
    var signal = abortController.signal;
    var mediaQuery = window.matchMedia('(max-width: 1099px)');
    var h5Origin = '';
    try { h5Origin = new URL(chatConfig.baseUrl, window.location.href).origin; } catch (error) {}
    // 埋点文档事件类型常量（对应 D:\ai-app\埋点\埋点文档.xls）
    var ET = {
      AI_LAB_ENTER_EXIT: 1,   // 进入/退出外部AI Lab页面
      AI_LAB_LOADED: 2,       // AI Lab 页面加载完成
      QUIZ_ANSWER: 3,         // AI Lover 测评答题
      MATCH_RESULT: 4,        // AI Lover 匹配结果展示
      EMAIL_SUBMIT: 5,        // 邮箱提交
      CHAT_PAGE_ENTER_EXIT: 6,// 进入 H5 聊天页面
      CHAT_PAGE_LOADED: 7,    // H5 聊天页面加载完成
      CHAT_LOGIN: 8,          // 在聊天页面登录
      CHAT_START_STOP: 9,     // 在聊天页面选择 AI Lover，开始/退出聊天
      GO_TO_BIGSHOCKED: 10    // 从AI Lab页面进入BIGSHOCKED站点
    };
  
    // Mobile: move the carousel between the quiz intro and the quiz card
    function rearrangeForMobile() {
      var layout = root.querySelector('.ai-lab-quiz-layout');
      var carousel = root.querySelector('.ai-lab-match-carousel');
      var quizCol = root.querySelector('.ai-lab-quiz-column');
      var quizCard = root.querySelector('.ai-lab-quiz-card');
      if (!layout || !carousel || !quizCol || !quizCard) return;
  
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 1099px)').matches;
      if (isMobile) {
        // Insert carousel right before the quiz card inside the quiz column
        quizCol.insertBefore(carousel, quizCard);
      } else {
        // Move carousel back as the first child of quiz-layout
        layout.insertBefore(carousel, quizCol);
      }
    }
  
    rearrangeForMobile();
    mediaQuery.addEventListener('change', rearrangeForMobile, { signal: signal });
  
    // 事件1: 进入页面（用快照 userId）
    track('page_enter_leave', { action: 'enter' }, ET.AI_LAB_ENTER_EXIT, 1, 0, true);
  
    // 事件1/6: 离开/进入页面
    // 用 visibilitychange 同时覆盖 PC 切后台、移动端锁屏/切后台
    // 不再用 beforeunload — 它在部分移动端浏览器不可靠，且会误触发（刷新/跳转也触发）
    // 每次 hidden→visible 都重新上报 enter，visible→hidden 都上报 leave
    // 页面真正销毁（关闭标签/杀浏览器）时 visibilitychange 不再触发，
    // 但 keepalive fetch 在 beforeunload 阶段仍能发出请求。
    (function () {
      var wasHidden = false;
  
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          wasHidden = true;
          track('page_enter_leave', { action: 'leave', stay_duration: Date.now() - getPageStartTime() }, ET.AI_LAB_ENTER_EXIT, 2, Date.now() - getPageStartTime(), true);
        } else if (document.visibilityState === 'visible') {
          if (wasHidden) {
            track('page_enter_leave', { action: 'enter' }, ET.AI_LAB_ENTER_EXIT, 1, 0, true);
            wasHidden = false;
          }
        }
      }, { signal: signal });
  
      // 前进按钮（bfcache 恢复）时重新记录进入
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
          wasHidden = false;
          track('page_enter_leave', { action: 'enter' }, ET.AI_LAB_ENTER_EXIT, 1, 0, true);
        }
      }, { signal: signal });
  
      // beforeunload 兜底：关闭标签/浏览器时最后一次尝试上报
      // 用 keepalive fetch，浏览器在 unload 阶段仍会尝试发出
      window.addEventListener('beforeunload', function () {
        track('page_enter_leave', { action: 'leave', stay_duration: Date.now() - getPageStartTime() }, ET.AI_LAB_ENTER_EXIT, 2, Date.now() - getPageStartTime(), true);
      }, { signal: signal });
    })();
  
    function parseTags(value) {
      return String(value || '')
        .split(',')
        .map(function (tag) { return tag.trim().toLowerCase(); })
        .filter(Boolean);
    }
  
    var characters = (config.characters || []).map(function (character, index) {
      var copy = {};
      for (var key in character) {
        if (Object.prototype.hasOwnProperty.call(character, key)) copy[key] = character[key];
      }
      copy.cardIndex = index;
      copy.index = index;
      copy.tagList = parseTags(copy.tags);
      return copy;
    });
  
    buildCharacterCards();
  
    var stage = root.querySelector('[data-ai-character-stage]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ai-character-card]'));
    var activeIndex = 0;
    var profileName = root.querySelector('[data-ai-profile-name]');
    var profilePersona = root.querySelector('[data-ai-profile-persona]');
    var profileGender = root.querySelector('[data-ai-profile-gender]');
    var profileTraits = root.querySelector('[data-ai-profile-traits]');
    var profileMood = root.querySelector('[data-ai-profile-mood]');
    var profileCopy = root.querySelector('[data-ai-profile-copy]');
  
    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
      });
    }
  
    function buildCharacterCards() {
      var stageEl = root.querySelector('[data-ai-character-stage]');
      if (!stageEl) return;
      var html = '';
      characters.forEach(function (character, index) {
        html += '<article class="ai-lab-character-card" data-ai-character-card data-index="' + index + '">';
        if (character.image) {
          html += '<img src="' + escapeHtml(character.image) + '" loading="lazy" alt="' + escapeHtml(character.name) + '">';
        } else {
          html += '<div class="ai-lab-character-fallback">' + escapeHtml(character.name || 'AI Lover') + '</div>';
        }
        html += '</article>';
      });
      stageEl.innerHTML = html;
    }
  
    function wrapIndex(index) {
      if (!characters.length) return 0;
      return (index + characters.length) % characters.length;
    }
  
    function descriptionFor(character) {
      return character._description || character.desktopDescription;
    }
  
    function updateCarousel(index) {
      if (!characters.length) return;
      activeIndex = wrapIndex(index);
      var prevIndex = wrapIndex(activeIndex - 1);
      var nextIndex = wrapIndex(activeIndex + 1);
  
      cards.forEach(function (card, cardIndex) {
        card.classList.remove('is-active', 'is-prev', 'is-next');
        if (cardIndex === activeIndex) card.classList.add('is-active');
        else if (cardIndex === prevIndex) card.classList.add('is-prev');
        else if (cardIndex === nextIndex) card.classList.add('is-next');
      });
  
      renderProfile(characters[activeIndex]);
    }
  
    function renderProfile(character) {
      if (!character) return;
      if (profileName) profileName.textContent = character.name || '';
      if (profilePersona) profilePersona.textContent = character._persona || character.persona || '';
      if (profileGender) profileGender.textContent = character._genderLabel || character.genderLabel || character.gender || '';
      if (profileTraits) {
        profileTraits.textContent = character._traits || character.traits || '';
        profileTraits.style.display = (character._traits || character.traits) ? '' : 'none';
      }
      if (profileMood) {
        var moodLabel = character._moodLabel || character.moodLabel;
        var moodValue = character._moodValue || character.moodValue;
        profileMood.textContent = [moodLabel, moodValue].filter(Boolean).join(': ');
        profileMood.style.display = moodValue ? '' : 'none';
      }
      if (profileCopy) profileCopy.textContent = descriptionFor(character) || '';
    }
  
    var prev = root.querySelector('[data-ai-prev]');
    var next = root.querySelector('[data-ai-next]');
    if (prev) prev.addEventListener('click', function () { updateCarousel(activeIndex - 1); }, { signal: signal });
    if (next) next.addEventListener('click', function () { updateCarousel(activeIndex + 1); }, { signal: signal });
  
    var pointerDown = false;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var dragDelta = 0;
    var dragStarted = false;
    var pointerCaptured = false;
    var lastPointerX = 0;
    var lastPointerTime = 0;
    var velocityX = 0;
    var suppressCardClickUntil = 0;
  
    function setDragOffset(value) {
      if (stage) stage.style.setProperty('--ai-drag-x', value + 'px');
    }
  
    function clearDragOffset() {
      if (stage) stage.style.removeProperty('--ai-drag-x');
    }
  
    function endCharacterDrag() {
      if (!pointerDown) return;
      pointerDown = false;
      if (stage) stage.classList.remove('is-dragging');
  
      if (!dragStarted) {
        clearDragOffset();
        return;
      }
  
      var threshold = stage ? Math.max(28, Math.min(76, stage.clientWidth * 0.13)) : 42;
      var quickSwipe = Math.abs(velocityX) > 0.55 && Math.abs(dragDelta) > 18;
      var targetIndex = activeIndex;
  
      if (dragDelta < -threshold || (quickSwipe && velocityX < 0)) {
        targetIndex = activeIndex + 1;
      } else if (dragDelta > threshold || (quickSwipe && velocityX > 0)) {
        targetIndex = activeIndex - 1;
      }
  
      updateCarousel(targetIndex);
      window.requestAnimationFrame(function () {
        clearDragOffset();
      });
  
      suppressCardClickUntil = Date.now() + 360;
      window.setTimeout(function () {
        dragDelta = 0;
        dragStarted = false;
        pointerCaptured = false;
        velocityX = 0;
      }, 360);
    }
  
    function beginCharacterDrag(clientX, clientY) {
      pointerDown = true;
      dragStarted = false;
      pointerCaptured = false;
      dragDelta = 0;
      velocityX = 0;
      pointerStartX = clientX;
      pointerStartY = clientY;
      lastPointerX = clientX;
      lastPointerTime = Date.now();
      clearDragOffset();
    }
  
    function moveCharacterDrag(clientX, clientY, event) {
      if (!pointerDown) return false;
  
      var deltaX = clientX - pointerStartX;
      var deltaY = clientY - pointerStartY;
  
      if (!dragStarted) {
        if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return false;
        if (Math.abs(deltaX) <= Math.abs(deltaY)) return false;
  
        dragStarted = true;
        if (stage) stage.classList.add('is-dragging');
      }
  
      if (!dragStarted) return false;
      if (event && event.cancelable) event.preventDefault();
  
      var now = Date.now();
      var elapsed = Math.max(1, now - lastPointerTime);
      velocityX = (clientX - lastPointerX) / elapsed;
      lastPointerX = clientX;
      lastPointerTime = now;
  
      var maxDrag = stage ? stage.clientWidth * 0.72 : 260;
      dragDelta = Math.max(-maxDrag, Math.min(maxDrag, deltaX));
      setDragOffset(dragDelta);
      return true;
    }
  
    if (stage) {
      stage.addEventListener('pointerdown', function (event) {
        if (characters.length < 2) return;
        if (event.button !== undefined && event.button !== 0) return;
        if (event.pointerType === 'touch') return;
  
        beginCharacterDrag(event.clientX, event.clientY);
      }, { signal: signal });
  
      stage.addEventListener('pointermove', function (event) {
        if (!pointerDown || event.pointerType === 'touch') return;
  
        var moved = moveCharacterDrag(event.clientX, event.clientY, event);
  
        if (moved && !pointerCaptured && typeof stage.setPointerCapture === 'function') {
          try {
            stage.setPointerCapture(event.pointerId);
            pointerCaptured = true;
          } catch (error) {}
        }
      }, { signal: signal });
  
      var endPointerDrag = function (event) {
        if (event && event.pointerType === 'touch') return;
        endCharacterDrag();
      };
  
      stage.addEventListener('pointerup', endPointerDrag, { signal: signal });
      stage.addEventListener('pointercancel', endPointerDrag, { signal: signal });
      stage.addEventListener('lostpointercapture', endPointerDrag, { signal: signal });
  
      stage.addEventListener('touchstart', function (event) {
        if (characters.length < 2 || event.touches.length !== 1) return;
        var touch = event.touches[0];
        beginCharacterDrag(touch.clientX, touch.clientY);
      }, { signal: signal, passive: true });
  
      stage.addEventListener('touchmove', function (event) {
        if (!pointerDown || event.touches.length !== 1) return;
        var touch = event.touches[0];
        moveCharacterDrag(touch.clientX, touch.clientY, event);
      }, { signal: signal, passive: false });
  
      stage.addEventListener('touchend', endCharacterDrag, { signal: signal, passive: true });
      stage.addEventListener('touchcancel', endCharacterDrag, { signal: signal, passive: true });
    }
  
    cards.forEach(function (card, index) {
      card.addEventListener('click', function (event) {
        if (Date.now() < suppressCardClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        updateCarousel(index);
      }, { signal: signal });
    });
  
    root.addEventListener('dragstart', function (event) {
      if (event.target && event.target.closest('[data-ai-character-stage]')) {
        event.preventDefault();
      }
    }, { signal: signal });
  
    updateCarousel(0);
    window.addEventListener('resize', function () { renderProfile(characters[activeIndex]); }, { signal: signal });
  
    var quiz = root.querySelector('[data-ai-quiz]');
    var quizCard = root.querySelector('.ai-lab-quiz-card');
    var questions = quiz ? Array.prototype.slice.call(quiz.querySelectorAll('[data-ai-question]')) : [];
    var questionProgress = root.querySelector('[data-ai-question-progress]');
    var backButton = root.querySelector('[data-ai-question-back]');
    var previewButton = root.querySelector('[data-ai-preview]');
    var alertNode = root.querySelector('[data-ai-quiz-alert]');
    var modal = root.querySelector('[data-ai-modal]');
    var modalClose = root.querySelector('[data-ai-modal-close]');
    var modalMedia = root.querySelector('[data-ai-modal-media]');
    var modalName = root.querySelector('[data-ai-modal-name]');
    var modalPersona = root.querySelector('[data-ai-modal-persona]');
    var modalGender = root.querySelector('[data-ai-modal-gender]');
    var modalTraits = root.querySelector('[data-ai-modal-traits]');
    var modalMood = root.querySelector('[data-ai-modal-mood]');
    var modalCopy = root.querySelector('[data-ai-modal-copy]');
  
    var startChatButton = root.querySelector('[data-ai-start-chat]');
    var termsCheckbox = root.querySelector('[data-terms-agree]');
    var marketingCheckbox = root.querySelector('[data-marketing-agree]');
    var privacyModal = root.querySelector('[data-privacy-policy-modal]');
    var privacyModalClose = root.querySelector('[data-privacy-policy-close]');
    var termsNoticeModal = root.querySelector('[data-terms-notice-modal]');
    var termsNoticeClose = root.querySelector('[data-terms-notice-close]');
    var openPrivacyLink = root.querySelector('[data-open-privacy-policy]');
    var openTermsNoticeLink = root.querySelector('[data-open-terms-notice]');
    var currentMatch = null;
    var chatEnterTime = 0;
  
    /* ---- Email confirm in match modal ---- */
    var matchEmailInput = root.querySelector('[data-match-email]');
    var matchEmailConfirmBtn = root.querySelector('[data-match-email-confirm]');
    var matchEmailMsg = root.querySelector('[data-match-email-msg]');
    var emailConfirmed = false;
    var emailRequestSequence = 0;
    var emailRequestPending = false;
    var aiLabDestroyed = false;
    var requestSignal = signal;
  
    // Cache email separately so it persists even when token is cleared
    var EMAIL_STORAGE_KEY = 'aiLoverEmail';
  
    function readStoredEmail() {
      try { return localStorage.getItem(EMAIL_STORAGE_KEY) || ''; } catch (e) { return ''; }
    }
    function storeEmail(email) {
      try { localStorage.setItem(EMAIL_STORAGE_KEY, email); } catch (e) {}
    }
  
    function setStartButtonState(enabled) {
      // 必须同时勾选两个复选框才能启用 Start chatting
      var termsOk = !termsCheckbox || termsCheckbox.checked;
      var marketingOk = !marketingCheckbox || marketingCheckbox.checked;
      if (startChatButton) startChatButton.disabled = !(enabled && termsOk && marketingOk);
    }
  
    function showEmailMessage(text, isError) {
      if (!matchEmailMsg) return;
      matchEmailMsg.textContent = text;
      matchEmailMsg.hidden = !text;
      matchEmailMsg.classList.toggle('is-error', !!isError);
      matchEmailMsg.classList.toggle('is-success', !isError);
    }
  
    function applyEmailCacheState() {
      var cachedEmail = readStoredEmail();
      var cachedToken = readStoredToken();
      if (cachedEmail && matchEmailInput) matchEmailInput.value = cachedEmail;
      // If we have both email and token cached, auto-enable start
      if (cachedEmail && cachedToken) {
        emailConfirmed = true;
        setStartButtonState(true);
        showEmailMessage('', false);
      } else {
        emailConfirmed = false;
        setStartButtonState(false);
      }
    }
  
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  
    function handleEmailConfirm() {
      if (!matchEmailInput || emailRequestPending || aiLabDestroyed) return;
      var email = matchEmailInput.value.trim();
      if (!email) {
        showEmailMessage('Please enter your email.', true);
        return;
      }
      if (!emailRegex.test(email)) {
        showEmailMessage('Please enter a valid email address.', true);
        return;
      }
  
      var emailLower = email.toLowerCase();
      var prevEmail = readStoredEmail().toLowerCase();
  
      // If email hasn't changed and we already have a valid token, skip re-request
      if (emailLower === prevEmail && readStoredToken()) {
        emailConfirmed = true;
        storeEmail(email);
        setStartButtonState(true);
        showEmailMessage('Email confirmed.', false);
        if (matchEmailConfirmBtn) matchEmailConfirmBtn.disabled = false;
  
        // 事件5: 邮箱提交（Match Modal，缓存命中）
        track('email_submit', {
          source_form: 'match_modal',
          email: email
        }, ET.EMAIL_SUBMIT);
        return;
      }
  
      var emailRequestId = ++emailRequestSequence;
      emailRequestPending = true;
      emailConfirmed = false;
      setStartButtonState(false);
      if (matchEmailConfirmBtn) matchEmailConfirmBtn.disabled = true;
      matchEmailInput.disabled = true;
      showEmailMessage('', false);
  
      exchangeEmailForToken(email).then(function (credentials) {
        if (
          aiLabDestroyed ||
          emailRequestId !== emailRequestSequence ||
          matchEmailInput.value.trim().toLowerCase() !== emailLower
        ) {
          return;
        }
  
        storeToken(credentials.token);
        if (credentials.userId) {
          try { localStorage.setItem('userId', String(credentials.userId)); } catch (e) {}
        }
        emailConfirmed = true;
        storeEmail(email);
        setStartButtonState(true);
        showEmailMessage('Email confirmed.', false);
  
        // 事件5: 邮箱提交（Match Modal）
        track('email_submit', {
          source_form: 'match_modal',
          email: email
        }, ET.EMAIL_SUBMIT);
      }).catch(function (error) {
        if (
          aiLabDestroyed ||
          emailRequestId !== emailRequestSequence ||
          (error && error.name === 'AbortError')
        ) {
          return;
        }
        emailConfirmed = false;
        setStartButtonState(false);
        showEmailMessage('Failed to verify email. Please try again.', true);
      }).then(function () {
        if (aiLabDestroyed || emailRequestId !== emailRequestSequence) return;
        emailRequestPending = false;
        matchEmailInput.disabled = false;
        if (matchEmailConfirmBtn) matchEmailConfirmBtn.disabled = false;
      });
    }
  
    if (matchEmailConfirmBtn) {
      matchEmailConfirmBtn.addEventListener('click', handleEmailConfirm, { signal: signal });
    }
  
    // Allow pressing Enter in email input to confirm
    if (matchEmailInput) {
      matchEmailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleEmailConfirm();
        }
      }, { signal: signal });
      // Reset confirmed state when user edits email
      matchEmailInput.addEventListener('input', function () {
        if (emailRequestPending) {
          emailRequestSequence += 1;
          emailRequestPending = false;
          matchEmailInput.disabled = false;
          if (matchEmailConfirmBtn) matchEmailConfirmBtn.disabled = false;
        }
        if (emailConfirmed) {
          emailConfirmed = false;
          setStartButtonState(false);
          showEmailMessage('', false);
        }
      }, { signal: signal });
    }
  
    // Apply cached state on load
    applyEmailCacheState();
  
    /* ---- Terms & marketing checkboxes gate Start button ---- */
    if (termsCheckbox) {
      termsCheckbox.addEventListener('change', function () {
        // 仅在 emailConfirmed 时才能解锁 Start
        setStartButtonState(emailConfirmed);
      }, { signal: signal });
    }
    if (marketingCheckbox) {
      marketingCheckbox.addEventListener('change', function () {
        setStartButtonState(emailConfirmed);
      }, { signal: signal });
    }
  
    /* ---- Terms / Privacy modals open / close ---- */
    function openTermsModal(m) { if (!m) return; m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); }
    function closeTermsModal(m) { if (!m) return; m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
  
    if (openPrivacyLink) openPrivacyLink.addEventListener('click', function (e) { e.preventDefault(); openTermsModal(privacyModal); }, { signal: signal });
    if (privacyModalClose) privacyModalClose.addEventListener('click', function () { closeTermsModal(privacyModal); }, { signal: signal });
    if (privacyModal) privacyModal.addEventListener('click', function (e) { if (e.target === privacyModal) closeTermsModal(privacyModal); }, { signal: signal });
  
    if (openTermsNoticeLink) openTermsNoticeLink.addEventListener('click', function (e) { e.preventDefault(); openTermsModal(termsNoticeModal); }, { signal: signal });
    if (termsNoticeClose) termsNoticeClose.addEventListener('click', function () { closeTermsModal(termsNoticeModal); }, { signal: signal });
    if (termsNoticeModal) termsNoticeModal.addEventListener('click', function (e) { if (e.target === termsNoticeModal) closeTermsModal(termsNoticeModal); }, { signal: signal });
  
    // Chat modal (new phone-style modal for H5 chat)
    var chatModal = root.querySelector('[data-ai-chat-modal]');
    var chatModalClose = root.querySelector('[data-ai-chat-modal-close]');
    var chatModalPanel = root.querySelector('.ai-lab-modal-panel--chat');
    var chatModalIframe = root.querySelector('[data-ai-chat-modal-iframe]');
    var CHAT_H5_BASE_URL = chatConfig.baseUrl || 'https://aichat-front.smartfeaturehub.com';
  
    function buildChatUrl() {
      var base = normalizeBase(CHAT_H5_BASE_URL);
      var token = readStoredToken();
  
      // 没 token 时进 H5 登录页（带回跳到 aiSwipe），让用户在 H5 里输入邮箱换 token
      if (!token) {
        return buildLoginUrl({ characterName: currentMatch ? currentMatch.name : '' });
      }
  
      var params = [];
      params.push('token=' + encodeURIComponent(token));
      try {
        var userId = localStorage.getItem('userId');
        if (userId) params.push('userId=' + encodeURIComponent(userId));
      } catch (e) {}
      if (currentMatch && currentMatch.name) params.push('character=' + encodeURIComponent(currentMatch.name));
      params.push('source=ailab');
      params.push('tracking_session=' + encodeURIComponent(trackingSessionId));
      var chatProductId = tracker ? tracker.getProductId() : '';
      if (chatProductId) params.push('product_id=' + encodeURIComponent(chatProductId));
      var query = params.length ? '?' + params.join('&') : '';
      return base + '/#/aiSwipe' + query;
    }
  
    function selectedInputs() {
      if (!quiz) return [];
      return Array.prototype.slice.call(quiz.querySelectorAll('input[type="radio"]:checked'));
    }
  
    function quizComplete() {
      return questions.length > 0 && selectedInputs().length === questions.length;
    }
  
    function questionAnswered(question) {
      return !!(question && question.querySelector('input[type="radio"]:checked'));
    }
  
    var activeQuestionIndex = 0;
  
    function setActiveQuestion(index) {
      if (!questions.length) return;
      activeQuestionIndex = Math.max(0, Math.min(index, questions.length - 1));
      questions.forEach(function (question, questionIndex) {
        var active = questionIndex === activeQuestionIndex;
        question.classList.toggle('is-active', active);
        question.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (quizCard) quizCard.classList.add('is-ready');
    }
  
    function updateQuizState() {
      var complete = quizComplete();
      var activeQuestion = questions[activeQuestionIndex];
      var onLastQuestion = activeQuestionIndex === questions.length - 1;
      var activeAnswered = questionAnswered(activeQuestion);
  
      if (questionProgress && questions.length) {
        questionProgress.textContent = 'Question ' + (activeQuestionIndex + 1) + ' / ' + questions.length;
      }
      if (backButton) backButton.hidden = activeQuestionIndex === 0;
      if (previewButton) {
        previewButton.hidden = !(onLastQuestion && activeAnswered);
        previewButton.disabled = !complete;
      }
      if (alertNode) alertNode.hidden = true;
    }
  
    function currentGender() {
      var gender = quiz ? quiz.querySelector('input[name^="ai_gender"]:checked') : null;
      return gender ? gender.value : 'both';
    }
  
    function selectedTagList() {
      var tags = [];
      selectedInputs().forEach(function (input) {
        tags = tags.concat(parseTags(input.dataset.tags));
      });
      return tags;
    }
  
    function scoreCharacter(character, tags) {
      return tags.reduce(function (score, tag) {
        return score + (character.tagList.indexOf(tag) !== -1 ? 1 : 0);
      }, 0);
    }
  
    function findMatch() {
      var gender = currentGender();
      var pool = characters.filter(function (character) {
        return gender === 'both' || character.gender === gender;
      });
      if (!pool.length) pool = characters.slice();
  
      var tags = selectedTagList();
      var best = pool[0];
      var bestScore = -1;
  
      pool.forEach(function (character) {
        var score = scoreCharacter(character, tags);
        if (score > bestScore) {
          bestScore = score;
          best = character;
        }
      });
  
      return best;
    }
  
    function renderMatch(character) {
      if (!character) return;
      if (modalName) modalName.textContent = character.name || '';
      if (modalPersona) modalPersona.textContent = character._persona || character.persona || '';
      if (modalGender) modalGender.textContent = character._genderLabel || character.genderLabel || character.gender || '';
      if (modalTraits) {
        modalTraits.textContent = character._traits || character.traits || '';
        modalTraits.style.display = (character._traits || character.traits) ? '' : 'none';
      }
      if (modalMood) {
        var moodLabel = character._moodLabel || character.moodLabel;
        var moodValue = character._moodValue || character.moodValue;
        modalMood.textContent = [moodLabel, moodValue].filter(Boolean).join(': ');
        modalMood.style.display = moodValue ? '' : 'none';
      }
      if (modalCopy) modalCopy.textContent = descriptionFor(character) || '';
  
      if (modalMedia) {
        if (character.image) {
          modalMedia.innerHTML = '<img src="' + character.image + '" alt="' + escapeHtml(character.name || 'AI Lover') + '">';
        } else {
          modalMedia.innerHTML = '<div class="ai-lab-character-fallback">' + escapeHtml(character.name || 'AI Lover') + '</div>';
        }
      }
    }
  
    function openModal(character) {
      currentMatch = character || null;
      renderMatch(character);
      // Re-apply email/token cache state each time modal opens
      applyEmailCacheState();
      if (!modal) return;
      root.classList.add('ai-lab-shell--overlay-active');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
  
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      root.classList.remove('ai-lab-shell--overlay-active');
      document.documentElement.style.overflow = previousOverflow;
    }
  
    function normalizeBase(value) {
      return String(value || '').replace(/#.*$/, '').replace(/\/+$/, '');
    }
  
    function readStoredToken() {
      var key = chatConfig.tokenStorageKey || 'aiLoverToken';
      try {
        return localStorage.getItem(key) || '';
      } catch (error) {
        return '';
      }
    }
  
    function storeToken(token) {
      if (!token) return;
      var key = chatConfig.tokenStorageKey || 'aiLoverToken';
      try {
        localStorage.setItem(key, token);
      } catch (error) {}
    }
  
    // 调后端接口的通用封装：自动带上 Bearer token。
    function apiRequest(pathName, body) {
      var base = normalizeBase(chatConfig.apiBaseUrl);
      if (!base) return Promise.reject(new Error('api base url missing'));
      var headers = { 'Content-Type': 'application/json' };
      var token = readStoredToken();
      if (token) headers['Authorization'] = 'Bearer ' + token;
      return fetch(base + '/' + pathName, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body || {}),
        signal: requestSignal
      }).then(function (res) { return res.json(); });
    }
  
    // 邮箱换 token：先返回凭证，调用方确认请求仍有效后再写入本地状态。
    function exchangeEmailForToken(email) {
      var channel = chatConfig.surface === 'shopify' ? 'bigshocked' : 'ai-lab';
      return apiRequest('auth/login', { email: email, channel: channel }).then(function (data) {
        var token = data && data.data && data.data.token;
        var userId = data && data.data && data.data.user_id;
        if (token) {
          return { token: token, userId: userId };
        }
        throw new Error((data && data.message) || 'login failed');
      });
    }
  
    function buildLoginUrl(opts) {
      var base = normalizeBase(chatConfig.baseUrl);
      if (!base) return '';
      var redirect = '/aiSwipe';
      var params = [];
      if (opts && opts.characterName) params.push('character=' + encodeURIComponent(opts.characterName));
      params.push('source=ailab');
      params.push('tracking_session=' + encodeURIComponent(trackingSessionId));
      if (params.length) redirect += '?' + params.join('&');
      return base + '/#/login?redirect=' + encodeURIComponent(redirect);
    }
  
    // Exposed so a backend integration or manual test can set a token.
    root.aiLabSetToken = storeToken;
  
    if (quiz) {
      quiz.addEventListener('change', function (event) {
        var input = event.target;
        if (!input || !input.matches('input[type="radio"]')) {
          updateQuizState();
          return;
        }
  
        var currentQuestion = input.closest('[data-ai-question]');
        var currentIndex = questions.indexOf(currentQuestion);
        updateQuizState();
  
        // 事件3: 答题选择（question_index 从1开始）
        // 记录用户看到的选项显示文本（当前语言的翻译文本），而不是 data-tags
        var optionLabel = input.closest('.ai-lab-option');
        var displayText = '';
        if (optionLabel) {
          var span = optionLabel.querySelector('span');
          if (span) displayText = span.textContent.trim();
        }
        track('quiz_answer' + (currentIndex + 1), {
          question_index: currentIndex + 1,
          question_name: input.name,
          selected_value: displayText || input.value
        }, ET.QUIZ_ANSWER);
  
        if (currentIndex > -1 && currentIndex === activeQuestionIndex && currentIndex < questions.length - 1) {
          window.setTimeout(function () {
            setActiveQuestion(currentIndex + 1);
            updateQuizState();
          }, 180);
        }
      }, { signal: signal });
    }
    if (backButton) {
      backButton.addEventListener('click', function () {
        setActiveQuestion(activeQuestionIndex - 1);
        updateQuizState();
      }, { signal: signal });
    }
    if (previewButton) {
      previewButton.addEventListener('click', function () {
        if (!quizComplete()) {
          updateQuizState();
          if (alertNode) alertNode.hidden = false;
          return;
        }
        var match = findMatch();
        if (match) {
          try { sessionStorage.setItem('aiLabLastMatchName', match.name || ''); } catch (error) {}
          // 事件4: 匹配结果展示
          track('match_result_show', {
            match_name: match.name,
            match_persona: match.persona,
            match_gender: match.gender
          }, ET.MATCH_RESULT);
          openModal(match);
        }
      }, { signal: signal });
    }
    if (modalClose) modalClose.addEventListener('click', closeModal, { signal: signal });
    // 已移除：点击弹窗外区域退出 Match Modal
    if (startChatButton) {
      startChatButton.addEventListener('click', function () {
        // 事件6: 进入H5聊天页面
        chatEnterTime = Date.now();
        track('chat_enter_leave', { action: 'enter', character_name: currentMatch ? currentMatch.name : '' }, ET.CHAT_PAGE_ENTER_EXIT, 1, 0);
  
        // 关闭 Match Modal，打开 Chat Modal（手机竖屏样式）
        closeModal();
        if (chatModal && chatModalIframe) {
          chatModalIframe.setAttribute('src', buildChatUrl());
          root.classList.add('ai-lab-shell--overlay-active');
          chatModal.classList.add('is-open');
          chatModal.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
        }
      }, { signal: signal });
    }
    if (chatModalClose) {
      chatModalClose.addEventListener('click', function () {
        if (!chatModal) return;
        track('chat_enter_leave', { action: 'leave', character_name: currentMatch ? currentMatch.name : '' }, ET.CHAT_PAGE_ENTER_EXIT, 2, Date.now() - chatEnterTime);
        chatModal.classList.remove('is-open');
        chatModal.setAttribute('aria-hidden', 'true');
        root.classList.remove('ai-lab-shell--overlay-active');
        document.documentElement.style.overflow = previousOverflow;
        if (chatModalIframe) chatModalIframe.removeAttribute('src');
      }, { signal: signal });
    }
    // 已移除：点击弹窗外区域退出 Chat Modal
  
    function onAiLabKeydown(event) {
      if (event.key !== 'Escape') return;
      if (termsNoticeModal && termsNoticeModal.classList.contains('is-open')) {
        closeTermsModal(termsNoticeModal);
        return;
      }
      if (privacyModal && privacyModal.classList.contains('is-open')) {
        closeTermsModal(privacyModal);
        return;
      }
      // 正在 chat modal 内：关闭它。
      if (chatModal && chatModal.classList.contains('is-open')) {
        track('chat_enter_leave', { action: 'leave', character_name: currentMatch ? currentMatch.name : '' }, ET.CHAT_PAGE_ENTER_EXIT, 2, Date.now() - chatEnterTime);
        chatModal.classList.remove('is-open');
        chatModal.setAttribute('aria-hidden', 'true');
        root.classList.remove('ai-lab-shell--overlay-active');
        document.documentElement.style.overflow = previousOverflow;
        if (chatModalIframe) chatModalIframe.removeAttribute('src');
        return;
      }
      closeModal();
    }
    document.addEventListener('keydown', onAiLabKeydown, { signal: signal });
  
    // H5 iframe 内点左上角的关闭键（aiSwipe 大图页）会发来这条消息：
    // 它的“上一级”在 iframe 内不存在，所以直接关掉整个弹窗，回到主网页。
    function onAiLabMessage(event) {
      if (!chatModalIframe || event.source !== chatModalIframe.contentWindow || event.origin !== h5Origin) return;
      var data = event && event.data;
      if (data && data.type === 'ai-lover:close') {
        // 事件6: 退出H5聊天页面
        track('chat_enter_leave', { action: 'leave', character_name: currentMatch ? currentMatch.name : '' }, ET.CHAT_PAGE_ENTER_EXIT, 2, Date.now() - chatEnterTime);
        if (chatModal && chatModal.classList.contains('is-open')) {
          chatModal.classList.remove('is-open');
          chatModal.setAttribute('aria-hidden', 'true');
          root.classList.remove('ai-lab-shell--overlay-active');
          document.documentElement.style.overflow = previousOverflow;
          if (chatModalIframe) chatModalIframe.removeAttribute('src');
        } else {
          closeModal();
        }
      }
      // 事件7、8、9 已由 chat.vue/login.vue 内部直接 track() 上报，父页面不再通过 postMessage 重复上报
    }
    window.addEventListener('message', onAiLabMessage, { signal: signal });
  
    var previousOverflow = document.documentElement.style.overflow;
    function destroy() {
      aiLabDestroyed = true;
      emailRequestSequence += 1;
      emailRequestPending = false;
      abortController.abort();
      document.removeEventListener('keydown', onAiLabKeydown);
      window.removeEventListener('message', onAiLabMessage);
      mediaQuery.removeEventListener('change', rearrangeForMobile);
      if (chatModalIframe) chatModalIframe.removeAttribute('src');
      document.documentElement.style.overflow = previousOverflow;
      root.classList.remove('ai-lab-shell--overlay-active', 'ai-lab-shell--floating-active');
      delete root.aiLabSetToken;
      delete root.__aiLabInstance;
    }
  
    var instance = { destroy: destroy };
    root.__aiLabInstance = instance;
  
    setActiveQuestion(0);
    updateQuizState();
  
    // 事件2: 页面加载完成
    track('page_load_complete', { character_count: characters.length, load_time: Date.now() - getPageStartTime() }, ET.AI_LAB_LOADED);
  
    // 事件10: 从AI Lab跳转joyhub下载页
    var ctaLink = root.querySelector('a[href*="joyhub.net"]');
    if (ctaLink) {
      ctaLink.addEventListener('click', function () {
        track('cta_link_click', { target_url: ctaLink.href }, ET.GO_TO_BIGSHOCKED);
      }, { signal: signal });
    }
  
    /* ---- Quiz preview image carousel (mirrors character carousel) ---- */
    (function () {
      var stage = root.querySelector('.ai-lab-match-carousel__stage');
      if (!stage) return;
  
      var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-quiz-slide]'));
      var total = slides.length;
      if (total < 2) {
        slides.forEach(function (s) { s.classList.add('is-active'); });
        return;
      }
  
      var activeIndex = 0;
  
      function wrapIndex(i) {
        return (i + total) % total;
      }
  
      function updateQuizCarousel(index) {
        activeIndex = wrapIndex(index);
        var prevIndex = wrapIndex(activeIndex - 1);
        var nextIndex = wrapIndex(activeIndex + 1);
  
        slides.forEach(function (slide, i) {
          slide.classList.remove('is-active', 'is-prev', 'is-next');
          if (i === activeIndex) slide.classList.add('is-active');
          else if (i === prevIndex) slide.classList.add('is-prev');
          else if (i === nextIndex) slide.classList.add('is-next');
        });
      }
  
      var prevBtn = root.querySelector('[data-quiz-prev]');
      var nextBtn = root.querySelector('[data-quiz-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { updateQuizCarousel(activeIndex - 1); }, { signal: signal });
      if (nextBtn) nextBtn.addEventListener('click', function () { updateQuizCarousel(activeIndex + 1); }, { signal: signal });
  
      // Drag / swipe support (same pattern as character carousel)
      var pointerDown = false;
      var previewStartX = 0;
      var dragDelta = 0;
      var dragStarted = false;
      var suppressClickUntil = 0;
  
      function setDragOffset(v) { stage.style.setProperty('--ai-drag-x', v + 'px'); }
      function clearDragOffset() { stage.style.removeProperty('--ai-drag-x'); }
  
      function endDrag() {
        if (!pointerDown) return;
        pointerDown = false;
        stage.classList.remove('is-dragging');
        if (!dragStarted) { clearDragOffset(); return; }
  
        var threshold = Math.max(28, Math.min(76, stage.clientWidth * 0.13));
        var target = activeIndex;
        if (dragDelta < -threshold) target = activeIndex + 1;
        else if (dragDelta > threshold) target = activeIndex - 1;
  
        updateQuizCarousel(target);
        window.requestAnimationFrame(clearDragOffset);
        suppressClickUntil = Date.now() + 360;
        window.setTimeout(function () { dragDelta = 0; dragStarted = false; }, 360);
      }
  
      stage.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        if (e.pointerType === 'touch') return;
        pointerDown = true; dragStarted = false; dragDelta = 0; previewStartX = e.clientX;
      }, { signal: signal });
      stage.addEventListener('pointermove', function (e) {
        if (!pointerDown || e.pointerType === 'touch') return;
        var dx = e.clientX - previewStartX;
        if (!dragStarted) {
          if (Math.abs(dx) < 8) return;
          dragStarted = true;
          stage.classList.add('is-dragging');
        }
        if (e.cancelable) e.preventDefault();
        var maxDrag = stage.clientWidth * 0.72;
        dragDelta = Math.max(-maxDrag, Math.min(maxDrag, dx));
        setDragOffset(dragDelta);
      }, { signal: signal });
      stage.addEventListener('pointerup', endDrag, { signal: signal });
      stage.addEventListener('pointercancel', endDrag, { signal: signal });
  
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        var touch = e.touches[0];
        pointerDown = true; dragStarted = false; dragDelta = 0; previewStartX = touch.clientX;
      }, { signal: signal, passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (!pointerDown || e.touches.length !== 1) return;
        var touch = e.touches[0];
        var dx = touch.clientX - previewStartX;
        if (!dragStarted) {
          if (Math.abs(dx) < 8) return;
          dragStarted = true;
          stage.classList.add('is-dragging');
        }
        var maxDrag = stage.clientWidth * 0.72;
        dragDelta = Math.max(-maxDrag, Math.min(maxDrag, dx));
        setDragOffset(dragDelta);
      }, { signal: signal, passive: false });
      stage.addEventListener('touchend', endDrag, { signal: signal, passive: true });
      stage.addEventListener('touchcancel', endDrag, { signal: signal, passive: true });
  
      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function (e) {
          if (Date.now() < suppressClickUntil) { e.preventDefault(); e.stopPropagation(); return; }
          updateQuizCarousel(i);
        }, { signal: signal });
      });
  
      root.addEventListener('dragstart', function (e) {
        if (e.target && e.target.closest('.ai-lab-match-carousel__stage')) e.preventDefault();
      }, { signal: signal });
  
      updateQuizCarousel(0);
    })();
  
    return instance;
  }

  function mountWithin(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-ai-lab-section]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots.push.apply(roots, scope.querySelectorAll('[data-ai-lab-section]'));
    roots.forEach(function (root) {
      if (root.__aiLabInstance) return;
      var config = readConfig(root);
      if (config) mountAiLab(root, config);
    });
  }

  function unmountWithin(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-ai-lab-section]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots.push.apply(roots, scope.querySelectorAll('[data-ai-lab-section]'));
    roots.forEach(function (root) {
      if (root.__aiLabInstance) root.__aiLabInstance.destroy();
    });
  }

  window.AILabTheme = { mount: mountAiLab, mountWithin: mountWithin, unmountWithin: unmountWithin };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountWithin(document); }, { once: true });
  } else {
    mountWithin(document);
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) { mountWithin(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmountWithin(event.target); });
  }
})();
